import React, { useState, useEffect } from "react";
import { API_URL } from "../../utils/ApiUrl";
import "./claimschedule.scss";
import Header from "../landing/Header/Header";
import Loader from "../../hooks/loader";
import axios from "axios";
import { useWeb3React } from "@web3-react/core";
import List from "./listSchedule";
import useAuth from "../../hooks/useAuth";
import { Link, useHistory } from "react-router-dom";
import LastClaimedDopMonth from "../../hooks/LastClaimedMonth";

const ClaimSchedule = () => {
  const [loader, setLoader] = useState(true);
  const [profile, setProfile] = useState(null);
  const [five, setFive] = useState(0);
  const [eight, setEight] = useState(0);
  const [last, setLast] = useState(0);
  const [lastClaimedMonth, setLastClaimedMonth] = useState(false);
  const { account } = useWeb3React();
  const { logout } = useAuth();
  const { LastClaimedMonth } = LastClaimedDopMonth();
  const history = useHistory();

  const getLastClaimedMonth = async (account) => {
    const lastMonth = await LastClaimedMonth(account);
    console.log(lastMonth);
    setLastClaimedMonth(lastMonth);
  };

  useEffect(() => {
    if (account) {
      getProfile();
      getLastClaimedMonth(account);
    }
  }, [account]);

  useEffect(() => {
    let timeoutId;
    if (!account) {
      timeoutId = setTimeout(() => {
        updateWallet();
      }, 2000);
    }

    // Cleanup the timeout to avoid memory leaks
    return () => clearTimeout(timeoutId);
  }, [account]);

  const updateWallet = async () => {
    if (!account) {
      const locaWallet = localStorage.getItem("connectorId");
      console.log("here");
      await logout(locaWallet);
      localStorage.clear();
      history.push("/");
    }
  };

  const getProfile = async () => {
    let token = localStorage.getItem("dopToken");
    // setLoader(true);
    var config = {
      method: "get",
      url: `${API_URL}users/profile`,

      headers: {
        Authorization: "Bearer " + token,
      },
      data: {},
    };
    await axios(config)
      .then(function (res) {
        const resss = res?.data.data;
        let date = new Date(resss?.rewardCreatedAt).toLocaleDateString();
        setProfile(resss);
        setLoader(false);
      })
      .catch(function (err) {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (profile) {
      let sum = profile?.dopPurchased + profile?.dopPurchasedByNft;
      let fi = sum * 0.05;
      let ei = sum * 0.0864;
      let li = sum * 0.0859;
      setFive(fi);
      setEight(ei);
      setLast(li);
    }
  }, [profile]);

  const schedule = [
    {
      id: 1,
      date: "2025-01-07T10:00:00Z",
      percentage: 5,
      claimContract: "0xF49e4197324059e819690a0588dec5AB25d3985C",
    },
    {
      id: 2,
      date: "2025-02-07T10:00:00Z",
      percentage: 8.64,
      claimContract: "0xec135D3aEe90a5119681Ce4317BA42281edA7b49",
    },
    {
      id: 3,
      date: "2025-03-07T10:00:00Z",
      percentage: 8.64,
      claimContract: "0xDC75915aE34C4Ba788dd31Da531f449773d717B9",
    },
    {
      id: 4,
      date: "2025-04-07T10:00:00Z",
      percentage: 8.64,
      claimContract: "0xb9F0ACa7A19155ed63024Ce301336a191DB7062F",
    },
    {
      id: 5,
      date: "2025-05-07T10:00:00Z",
      // date: "2025-03-26T19:35:00Z",
      percentage: 8.64,
      claimContract: "0xb9F0ACa7A19155ed63024Ce301336a191DB7062F",
    },
    {
      id: 6,
      date: "2025-06-07T10:00:00Z",
      // date: "2025-03-26T19:40:00Z",
      percentage: 8.64,
      claimContract: "0xb9F0ACa7A19155ed63024Ce301336a191DB7062F",
    },
    {
      id: 7,
      date: "2025-07-07T10:00:00Z",
      // date: "2025-03-26T19:45:00Z",
      percentage: 8.64,
      claimContract: "0xb9F0ACa7A19155ed63024Ce301336a191DB7062F",
    },
    {
      id: 8,
      date: "2025-08-07T10:00:00Z",
      // date: "2025-03-26T19:50:00Z",
      percentage: 8.64,
      claimContract: "0xb9F0ACa7A19155ed63024Ce301336a191DB7062F",
    },
    {
      id: 9,
      date: "2025-09-07T10:00:00Z",
      // date: "2025-03-26T19:55:00Z",
      percentage: 8.64,
      claimContract: "0xb9F0ACa7A19155ed63024Ce301336a191DB7062F",
    },
    {
      id: 10,
      date: "2025-10-07T10:00:00Z",
      // date: "2025-03-26T20:00:00Z",
      percentage: 8.64,
      claimContract: "0xb9F0ACa7A19155ed63024Ce301336a191DB7062F",
    },
    {
      id: 11,
      date: "2025-11-07T10:00:00Z",
      // date: "2025-03-26T20:05:00Z",
      percentage: 8.64,
      claimContract: "0xb9F0ACa7A19155ed63024Ce301336a191DB7062F",
    },
    {
      id: 12,
      date: "2025-12-07T10:00:00Z",
      // date: "2025-03-26T20:10:00Z",
      percentage: 8.59,
      claimContract: "0xb9F0ACa7A19155ed63024Ce301336a191DB7062F",
    },
  ];

  return (
    <>
      <Header />
      {loader && <Loader />}
      <section className="claim-schedule">
        <div className="custom-container">
          <div className="main-head">
            <h6>LEIA CLAIMS</h6>
          </div>
          <div className="inline-elem">
            <div className="single">
              <h6>
                {" "}
                {(
                  profile?.dopPurchased + profile?.dopPurchasedByNft
                )?.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{" "}
                LEIA
              </h6>
              <p>TOTAL TOKENS</p>
            </div>
            <div className="single">
              <h6>
                {(
                  profile?.dopPurchased - profile?.dopPurchasedByNft
                ).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{" "}
                LEIA
              </h6>
              <p>LEIA Tokens</p>
            </div>
            <div className="single">
              <h6>
                {profile?.dopPurchasedByNft.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{" "}
                LEIA
              </h6>
              <p>LEIA tokens associated with NFTs</p>
            </div>
          </div>
          <div className="bottom-content">
            <h6 className="head-text">Claiming Schedule</h6>
            <div className="table-responsive claiming-schedule-table">
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      <div className="parent-tag">Claim No.</div>
                    </th>
                    <th>
                      <div className="parent-tag">Date</div>
                    </th>
                    <th>
                      <div
                        className="parent-tag"
                        style={{ textAlign: "center" }}
                      >
                        Percentage
                      </div>
                    </th>
                    <th>
                      <div
                        className="parent-tag"
                        style={{ textAlign: "center" }}
                      >
                        CLAIM AVAILABLE IN
                      </div>
                    </th>
                    <th>
                      <div
                        className="parent-tag"
                        style={{ textAlign: "center" }}
                      >
                        Amount
                      </div>
                    </th>
                    <th>
                      <div
                        className="parent-tag"
                        style={{ textAlign: "center" }}
                      >
                        ACTION
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {schedule?.map((item, index) => {
                    return (
                      <List
                        five={five}
                        eight={eight}
                        last={last}
                        item={item}
                        index={index}
                        lastClaimedMonth={lastClaimedMonth}
                      />
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ClaimSchedule;
